module.exports = __webpack_public_path__ + "static/img/5.2626459.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/2/eng/5.png
// module id = W6q4
// module chunks = 0